import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);
// import VConsole from 'vconsole';
Vue.use(ElementUI);
Vue.config.productionTip = false
// if (process.env.NODE_ENV === 'development') { new VConsole(); }
// new VConsole();
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});